/**
 * Position Search Keywords Configuration
 * Maps position titles to common search terms, aliases, and related keywords
 * Used to enhance search functionality in position selection
 */

export const positionKeywords = {
  // Tech Positions
  'Developer - Full Stack': [
    'fullstack', 'full stack', 'full-stack', 'developer', 'dev',
    'programmer', 'engineer', 'software engineer', 'web developer',
    'frontend', 'backend', 'react', 'node', 'javascript', 'js',
    'php', 'laravel', 'python', 'coding', 'coder', 'software dev'
  ],

  'Developer - Frontend': [
    'frontend', 'front-end', 'front end', 'developer', 'dev',
    'ui developer', 'web developer', 'react developer', 'vue developer',
    'angular developer', 'javascript', 'js', 'css', 'html',
    'web dev', 'interface developer', 'client-side', 'ui engineer'
  ],

  'Developer - Backend - Laravel': [
    'backend', 'back-end', 'back end', 'developer', 'dev',
    'laravel', 'php', 'api', 'server', 'server-side',
    'database', 'mysql', 'rest api', 'api developer',
    'php developer', 'laravel developer', 'backend engineer'
  ],

  'Developer - Backend': [
    'backend', 'back-end', 'back end', 'developer', 'dev',
    'server', 'api', 'database', 'node', 'python', 'java',
    'server-side', 'rest api', 'api developer', 'backend engineer',
    'microservices', 'cloud', 'aws'
  ],

  'Developer - Mobile': [
    'mobile', 'mobile developer', 'app developer', 'ios', 'android',
    'react native', 'flutter', 'swift', 'kotlin', 'mobile dev',
    'mobile engineer', 'app dev', 'mobile app', 'native app'
  ],

  'UX/UI Designer': [
    'ux', 'ui', 'ux/ui', 'ui/ux', 'user experience', 'user interface',
    'designer', 'design', 'product designer', 'interface designer',
    'figma', 'sketch', 'adobe xd', 'wireframe', 'prototype',
    'usability', 'interaction design', 'visual designer'
  ],

  'QA Engineer': [
    'qa', 'quality assurance', 'tester', 'test engineer', 'testing',
    'automation', 'selenium', 'test automation', 'manual testing',
    'software tester', 'quality engineer', 'qa analyst', 'sdet',
    'test analyst', 'bug finder'
  ],

  'DevOps Engineer': [
    'devops', 'dev ops', 'infrastructure', 'cloud', 'aws', 'azure',
    'docker', 'kubernetes', 'ci/cd', 'deployment', 'automation',
    'sre', 'site reliability', 'infrastructure engineer', 'cloud engineer',
    'systems engineer', 'pipeline', 'jenkins'
  ],

  'Data Analyst': [
    'data', 'analyst', 'data analyst', 'analytics', 'bi', 'business intelligence',
    'sql', 'excel', 'tableau', 'power bi', 'data analysis',
    'data science', 'statistics', 'reporting', 'insights'
  ],

  'Data Engineer': [
    'data engineer', 'data', 'big data', 'etl', 'pipeline',
    'spark', 'hadoop', 'sql', 'database', 'data warehouse',
    'airflow', 'kafka', 'python', 'data architecture'
  ],

  // Tech Leadership Positions
  'CTO': [
    'cto', 'chief technology officer', 'tech director', 'technology director',
    'vp technology', 'vp tech', 'head of technology', 'tech lead',
    'technical director', 'technology head', 'tech executive',
    'chief technical officer', 'engineering director'
  ],

  'Technical Team Lead': [
    'tech lead', 'team lead', 'lead developer', 'lead engineer',
    'engineering lead', 'development lead', 'senior developer',
    'tech team lead', 'technical lead', 'development manager',
    'engineering manager', 'lead dev', 'squad lead'
  ],

  'Product Manager': [
    'product manager', 'pm', 'product', 'product owner', 'po',
    'product lead', 'product management', 'product strategy',
    'agile product', 'scrum product', 'product director',
    'digital product manager'
  ],

  'Engineering Manager': [
    'engineering manager', 'development manager', 'team manager',
    'tech manager', 'software manager', 'manager', 'lead',
    'head of engineering', 'engineering lead', 'dev manager'
  ],

  'Solutions Architect': [
    'solutions architect', 'architect', 'technical architect',
    'software architect', 'system architect', 'enterprise architect',
    'cloud architect', 'infrastructure architect', 'solution designer'
  ],

  // Creative Positions
  'Graphic Designer': [
    'graphic designer', 'designer', 'visual designer', 'graphics',
    'photoshop', 'illustrator', 'adobe', 'creative designer',
    'brand designer', 'print designer', 'digital designer',
    'layout designer', 'visual artist'
  ],

  'Art Director': [
    'art director', 'creative director', 'design director',
    'visual director', 'senior designer', 'creative lead',
    'design lead', 'artistic director', 'visual lead'
  ],

  'Illustrator': [
    'illustrator', 'artist', 'illustration', 'digital artist',
    'graphic artist', 'visual artist', 'drawer', 'sketcher',
    'adobe illustrator', 'vector artist', 'character designer',
    'concept artist'
  ],

  'Creative Director': [
    'creative director', 'creative lead', 'design director',
    'head of creative', 'creative head', 'art director',
    'chief creative officer', 'cco', 'creative manager',
    'creative supervisor'
  ],

  'Brand Designer': [
    'brand designer', 'branding', 'brand', 'identity designer',
    'brand identity', 'logo designer', 'visual identity',
    'brand strategist', 'corporate identity'
  ],

  'Motion Graphics Designer': [
    'motion graphics', 'motion designer', 'animator',
    'after effects', 'animation', 'motion', 'video graphics',
    'animated graphics', 'video animator', '2d animator'
  ],

  // Digital Marketing Positions
  'Digital Marketing Manager': [
    'digital marketing', 'marketing manager', 'digital manager',
    'online marketing', 'performance marketing', 'marketing',
    'digital strategy', 'marketing lead', 'digital lead',
    'marketing director', 'growth manager', 'acquisition manager'
  ],

  'SEO Specialist': [
    'seo', 'seo specialist', 'search engine optimization',
    'organic search', 'search marketing', 'seo expert',
    'seo analyst', 'seo consultant', 'search specialist',
    'google seo', 'organic marketing', 'search engine'
  ],

  'SEO Manager': [
    'seo manager', 'seo', 'search manager', 'organic manager',
    'seo lead', 'search marketing manager', 'seo director',
    'search engine manager', 'organic search manager'
  ],

  'Community Manager': [
    'community manager', 'community', 'engagement manager',
    'social manager', 'community lead', 'engagement specialist',
    'community moderator', 'community strategist', 'online community'
  ],

  'PPC Specialist': [
    'ppc', 'ppc specialist', 'paid ads', 'google ads', 'sem',
    'paid marketing', 'paid search', 'adwords', 'paid media',
    'performance marketing', 'paid advertising', 'search ads'
  ],

  'Email Marketing Specialist': [
    'email marketing', 'email', 'email campaigns', 'crm',
    'marketing automation', 'email specialist', 'email manager',
    'newsletter', 'mailchimp', 'hubspot', 'email strategist'
  ],

  // Social Media Positions
  'Social Media Account Manager': [
    'social media', 'social manager', 'social media manager',
    'account manager', 'sm manager', 'social account',
    'social media lead', 'community manager', 'social lead',
    'social media coordinator', 'facebook', 'instagram', 'tiktok'
  ],

  'Social Media Strategist': [
    'social media strategist', 'social strategist', 'social strategy',
    'social media strategy', 'digital strategist', 'social planner',
    'social media planner', 'content strategist', 'social lead'
  ],

  'Content Creator': [
    'content creator', 'content', 'creator', 'social media creator',
    'content producer', 'digital content', 'video creator',
    'influencer', 'content specialist', 'social content',
    'content writer', 'copywriter'
  ],

  'Social Media Coordinator': [
    'social media coordinator', 'social coordinator', 'coordinator',
    'social media assistant', 'social assistant', 'social media exec',
    'social executive', 'community coordinator'
  ],

  // Video/Photo Positions
  'Videographer': [
    'videographer', 'video', 'video production', 'cameraman',
    'video producer', 'filmmaker', 'camera operator',
    'video specialist', 'video creator', 'cinematographer',
    'shooter', 'video shooter'
  ],

  'Photographer': [
    'photographer', 'photography', 'photo', 'camera',
    'portrait photographer', 'commercial photographer',
    'product photographer', 'studio photographer', 'shooter',
    'photo specialist'
  ],

  'Videographer/Editor': [
    'videographer editor', 'video editor', 'editor', 'editing',
    'premiere', 'final cut', 'video production', 'post production',
    'video specialist', 'filmmaker', 'video producer'
  ],

  'Video Editor': [
    'video editor', 'editor', 'editing', 'video editing',
    'premiere', 'final cut', 'davinci', 'post production',
    'video post', 'montage', 'video specialist'
  ],

  'Director of Photography': [
    'dop', 'director of photography', 'cinematographer',
    'dp', 'camera director', 'photography director',
    'visual director', 'chief photographer'
  ],

  // Post Production Positions
  '3D Artist': [
    '3d artist', '3d', 'three d', 'modeler', '3d modeler',
    'maya', 'blender', '3d designer', '3d animator',
    'cinema 4d', 'c4d', '3d specialist', 'cgi artist'
  ],

  'Animator': [
    'animator', 'animation', '2d animator', '3d animator',
    'motion designer', 'character animator', 'after effects',
    'motion graphics', 'animated', 'motion artist'
  ],

  'VFX Artist': [
    'vfx', 'vfx artist', 'visual effects', 'effects artist',
    'compositing', 'after effects', 'nuke', 'vfx specialist',
    'special effects', 'cgi', 'post production'
  ],

  'Colorist': [
    'colorist', 'color grading', 'color correction', 'grading',
    'davinci resolve', 'color', 'post production', 'color specialist',
    'grading artist'
  ],

  'Post Production Supervisor': [
    'post production supervisor', 'post supervisor', 'post manager',
    'post production manager', 'post production lead',
    'post production director', 'post lead'
  ],

  // Production Positions
  'Production Manager': [
    'production manager', 'production', 'producer manager',
    'project manager', 'pm', 'production lead',
    'production coordinator', 'production director',
    'production supervisor'
  ],

  'Producer': [
    'producer', 'production', 'content producer', 'video producer',
    'creative producer', 'project producer', 'production specialist',
    'executive producer', 'production lead'
  ],

  'Head of Production': [
    'head of production', 'production head', 'production director',
    'director of production', 'production vp', 'vp production',
    'chief production', 'production executive'
  ],

  'Project Manager': [
    'project manager', 'pm', 'project lead', 'project coordinator',
    'agile pm', 'scrum master', 'project director',
    'delivery manager', 'program manager'
  ],

  // Sales Positions
  'Account Manager': [
    'account manager', 'account', 'am', 'client manager',
    'relationship manager', 'account executive', 'client executive',
    'sales manager', 'business manager', 'key account manager',
    'kam', 'client relations'
  ],

  'Account Executive': [
    'account executive', 'ae', 'sales executive', 'account',
    'sales rep', 'sales', 'business development', 'bd',
    'sales representative', 'client executive'
  ],

  'Account Director': [
    'account director', 'client director', 'sales director',
    'business director', 'director', 'senior account',
    'head of accounts', 'commercial director'
  ],

  'Business Development Manager': [
    'business development', 'bd manager', 'bdr', 'bd',
    'sales manager', 'new business', 'growth manager',
    'partnerships', 'business manager', 'sales lead'
  ],

  'Sales Manager': [
    'sales manager', 'sales', 'sales lead', 'sales director',
    'sales head', 'commercial manager', 'revenue manager',
    'account manager', 'business manager'
  ],

  // HR Positions
  'HR Manager': [
    'hr manager', 'hr', 'human resources', 'hr lead',
    'people manager', 'hr director', 'human resources manager',
    'people operations', 'hr head', 'personnel manager'
  ],

  'Talent Acquisition Manager': [
    'talent acquisition', 'ta manager', 'recruiter', 'recruitment',
    'hiring manager', 'talent manager', 'ta', 'recruitment manager',
    'head of recruitment', 'talent lead', 'hiring lead'
  ],

  'HR Coordinator': [
    'hr coordinator', 'hr', 'hr assistant', 'hr executive',
    'human resources coordinator', 'people coordinator',
    'hr specialist', 'hr officer'
  ],

  'Recruiter': [
    'recruiter', 'recruitment', 'talent acquisition', 'ta',
    'hiring', 'hr recruiter', 'talent recruiter',
    'recruitment specialist', 'hiring specialist'
  ],

  // Finance Positions
  'Accountant': [
    'accountant', 'accounting', 'accounts', 'bookkeeper',
    'financial accountant', 'staff accountant', 'accountancy',
    'cpa', 'finance', 'accounts executive'
  ],

  'Finance Director': [
    'finance director', 'cfo', 'chief financial officer',
    'finance head', 'financial director', 'director of finance',
    'vp finance', 'finance vp', 'head of finance'
  ],

  'Financial Analyst': [
    'financial analyst', 'finance analyst', 'analyst',
    'fp&a', 'financial planning', 'finance', 'budget analyst',
    'financial controller'
  ],

  // Operations
  'Operations Manager': [
    'operations manager', 'operations', 'ops manager',
    'operations lead', 'operations director', 'ops',
    'business operations', 'ops lead'
  ],

  // Copywriting
  'Copywriter': [
    'copywriter', 'writer', 'content writer', 'copy',
    'creative writer', 'advertising writer', 'marketing writer',
    'digital copywriter', 'content creator', 'editor'
  ],

  'Content Writer': [
    'content writer', 'writer', 'content', 'copywriter',
    'blog writer', 'article writer', 'seo writer',
    'digital writer', 'web content writer'
  ],

  // Strategy
  'Strategist': [
    'strategist', 'strategy', 'strategic planner', 'brand strategist',
    'digital strategist', 'marketing strategist', 'business strategist',
    'strategy consultant', 'planner'
  ],

  // Additional Tech Positions
  'AI Engineer': [
    'ai', 'artificial intelligence', 'machine learning', 'ml',
    'deep learning', 'neural network', 'data science', 'ai engineer',
    'ml engineer', 'ai specialist', 'tensorflow', 'pytorch',
    'nlp', 'computer vision', 'ai developer'
  ],

  'Developer - Backend - Python': [
    'python', 'backend', 'back-end', 'django', 'flask',
    'fastapi', 'python developer', 'python engineer', 'api',
    'rest api', 'server', 'backend python'
  ],

  'Developer - Backend - Laravel/Python': [
    'laravel', 'python', 'backend', 'php', 'django',
    'full stack', 'api', 'developer', 'backend engineer',
    'laravel python', 'php python'
  ],

  'Developer - Wordpress': [
    'wordpress', 'wp', 'cms', 'php', 'web developer',
    'wordpress developer', 'wordpress engineer', 'woocommerce',
    'wordpress theme', 'wordpress plugin'
  ],

  'UX/UI - Researcher': [
    'ux researcher', 'user researcher', 'ux research',
    'user experience research', 'usability researcher',
    'user testing', 'research', 'ux', 'ui', 'user research'
  ],

  'Developer - Frontend - Senior': [
    'senior frontend', 'senior front-end', 'lead frontend',
    'frontend lead', 'senior developer', 'senior ui developer',
    'senior react', 'senior javascript', 'senior web developer'
  ],

  'Developer - Backend - Senior': [
    'senior backend', 'senior back-end', 'lead backend',
    'backend lead', 'senior developer', 'senior api developer',
    'senior server', 'senior database'
  ],

  'Developer - Full Stack - Senior': [
    'senior full stack', 'senior fullstack', 'lead developer',
    'senior developer', 'senior software engineer',
    'senior web developer', 'lead full stack'
  ],

  'Developer - Wordpress - Senior': [
    'senior wordpress', 'senior wp', 'lead wordpress',
    'wordpress lead', 'senior cms developer'
  ],

  // Production Positions
  'Stylist - Wardrobe': [
    'stylist', 'wardrobe stylist', 'fashion stylist',
    'wardrobe', 'costume', 'clothing stylist', 'style',
    'fashion', 'wardrobe supervisor'
  ],

  'Hair Stylist': [
    'hair stylist', 'hairstylist', 'hair', 'hair artist',
    'hair makeup', 'hair designer', 'hairdresser',
    'hair specialist'
  ],

  'Makeup Artist': [
    'makeup artist', 'makeup', 'mua', 'cosmetics',
    'beauty artist', 'makeup designer', 'beauty makeup',
    'makeup specialist', 'cosmetic artist'
  ],

  'Set Designer': [
    'set designer', 'set design', 'production designer',
    'scenic designer', 'set decorator', 'set builder',
    'art department', 'set artist'
  ],

  'Production Assistant': [
    'production assistant', 'pa', 'production support',
    'production coordinator', 'assistant producer',
    'production helper', 'set assistant'
  ],

  // Post Production Positions
  'Retoucher - Beauty and Fashion': [
    'retoucher', 'retouching', 'photo retoucher',
    'beauty retoucher', 'fashion retoucher', 'photoshop',
    'photo editor', 'image retouching', 'beauty editing',
    'fashion editing', 'skin retouching'
  ],

  'Retoucher - Jewellery and Products': [
    'retoucher', 'product retoucher', 'jewelry retoucher',
    'jewellery retoucher', 'product photo', 'product editing',
    'ecommerce retoucher', 'commercial retoucher'
  ],

  'Post Production Producer': [
    'post production producer', 'post producer',
    'post production manager', 'post supervisor',
    'post production coordinator', 'post pm'
  ],

  'Editor': [
    'editor', 'video editor', 'editing', 'premiere',
    'final cut', 'post production', 'video editing',
    'film editor', 'cutter', 'montage'
  ],

  // Social Media Positions
  'Influencer': [
    'influencer', 'content creator', 'social media influencer',
    'digital influencer', 'online influencer', 'creator',
    'social influencer', 'brand ambassador'
  ],

  // Creative Positions
  'Branding Art Director': [
    'branding', 'brand art director', 'brand designer',
    'art director', 'brand identity', 'brand creative',
    'branding director', 'identity designer'
  ],

  'Art Director - Ai': [
    'ai art director', 'artificial intelligence art',
    'ai creative', 'ai designer', 'art director ai',
    'ai art', 'generative art', 'ai branding'
  ],

  'Product Designer': [
    'product designer', 'product design', 'industrial design',
    'product developer', 'ui/ux', 'ux designer',
    'digital product', 'product manager', 'design lead'
  ],

  'Industrial Designer': [
    'industrial designer', 'industrial design', 'product design',
    'cad designer', '3d product', 'product development',
    'mechanical design', 'prototype designer'
  ],

  'Associate Creative Director': [
    'associate creative director', 'acd', 'associate cd',
    'creative lead', 'senior art director', 'creative manager',
    'deputy creative director'
  ],

  'Motion Designer': [
    'motion designer', 'motion graphics designer',
    'motion', 'after effects', 'animation designer',
    'motion artist', 'animated graphics', 'kinetic designer'
  ],

  'Creative Copywriter - English': [
    'copywriter', 'english copywriter', 'writer',
    'content writer', 'creative writer', 'copy',
    'advertising writer', 'english writer', 'english copy'
  ],

  'Creative Copywriter - Arabic': [
    'arabic copywriter', 'arabic writer', 'copywriter',
    'arabic content', 'arabic copy', 'bilingual writer',
    'arabic creative writer'
  ],

  // Digital Marketing Positions
  'Marketing Manager': [
    'marketing manager', 'marketing', 'marketing lead',
    'marketing director', 'brand manager', 'marketing head',
    'digital marketing', 'marketing strategy'
  ],

  'Public Relations Manager': [
    'pr manager', 'public relations', 'pr', 'communications',
    'media relations', 'press', 'pr director',
    'communications manager', 'public affairs'
  ],

  'Public Relations Director': [
    'pr director', 'public relations director', 'head of pr',
    'communications director', 'chief communications',
    'pr head', 'media director'
  ],

  'Head of Digital': [
    'head of digital', 'digital director', 'digital head',
    'chief digital officer', 'cdo', 'director of digital',
    'digital vp', 'digital executive'
  ],

  // Leadership Positions
  'Software Engineering Manager': [
    'software engineering manager', 'engineering manager',
    'software manager', 'development manager', 'eng manager',
    'software lead', 'engineering director', 'dev manager'
  ],

  'Head of UX': [
    'head of ux', 'ux director', 'ux head', 'design director',
    'user experience director', 'chief design officer',
    'vp ux', 'ux leader'
  ],

  'Technical Project Manager': [
    'technical pm', 'technical project manager',
    'tech pm', 'technical program manager', 'tpm',
    'it project manager', 'tech project lead'
  ],

  'IT Manager': [
    'it manager', 'it director', 'information technology',
    'it head', 'technology manager', 'systems manager',
    'it infrastructure', 'it operations'
  ],

  // HR Positions
  'Head of Operation': [
    'head of operations', 'operations director', 'coo',
    'chief operations officer', 'operations head',
    'director of operations', 'vp operations'
  ],

  'Administrative Assistant': [
    'administrative assistant', 'admin assistant', 'admin',
    'office assistant', 'secretary', 'administrative support',
    'office admin', 'administrative coordinator'
  ],

  'Executive Assistant': [
    'executive assistant', 'ea', 'executive support',
    'personal assistant', 'chief of staff', 'executive coordinator',
    'senior assistant', 'c-level assistant'
  ],

  'Operations Director': [
    'operations director', 'director of operations', 'ops director',
    'operations vp', 'chief operations', 'operations executive'
  ],

  'Learning and Development Director': [
    'l&d director', 'learning director', 'training director',
    'learning and development', 'l&d', 'talent development',
    'learning manager', 'training manager'
  ],

  'Traffic Manager': [
    'traffic manager', 'traffic coordinator', 'project traffic',
    'workflow manager', 'resource manager', 'production traffic',
    'project coordinator'
  ],

  'Director of Recruitment': [
    'director of recruitment', 'recruitment director',
    'talent director', 'hiring director', 'talent acquisition director',
    'head of recruitment', 'chief talent officer'
  ],

  'Talent Acquisition Specialist': [
    'talent acquisition', 'ta specialist', 'recruiter',
    'talent specialist', 'hiring specialist', 'recruitment specialist',
    'ta', 'sourcing specialist'
  ],

  // Sales Positions
  'Head of Luxury Services': [
    'head of luxury', 'luxury director', 'luxury services',
    'premium services', 'luxury accounts', 'vip services',
    'luxury business', 'high-end services'
  ],

  'Head of Accounts': [
    'head of accounts', 'accounts director', 'account director',
    'client services director', 'account management director',
    'head of client services'
  ],

  'Head of Government Services': [
    'head of government', 'government director',
    'public sector director', 'government services',
    'government accounts', 'public sector lead'
  ],

  'Account Manager - Business Growth': [
    'business growth', 'account manager growth', 'growth manager',
    'business development', 'expansion manager', 'growth account',
    'new business manager'
  ],

  'Account Director - Business Growth': [
    'business growth director', 'growth director',
    'business development director', 'expansion director',
    'new business director', 'growth account director'
  ],

  'Account Executive - Business Growth': [
    'business growth executive', 'growth executive',
    'business development executive', 'growth ae',
    'new business executive'
  ],

  // Finance Positions
  'Head of Investment': [
    'head of investment', 'investment director', 'investment manager',
    'chief investment officer', 'cio', 'investment head',
    'portfolio director', 'investment lead'
  ],

  'Financial Controller': [
    'financial controller', 'controller', 'finance controller',
    'accounting manager', 'financial manager', 'comptroller',
    'fc', 'finance lead'
  ],

  // Video/Photo Positions
  'Assistant Photographer': [
    'assistant photographer', 'photo assistant',
    'photographer assistant', 'photography assistant',
    'camera assistant', 'second shooter'
  ],

  'Photographer - Jewelry and Product': [
    'product photographer', 'jewelry photographer',
    'jewellery photographer', 'product photography',
    'ecommerce photographer', 'commercial photographer',
    'still life photographer'
  ],

  // Other Positions
  'CEO': [
    'ceo', 'chief executive officer', 'chief executive',
    'executive director', 'president', 'managing director',
    'md', 'founder', 'owner'
  ],

  'Driver': [
    'driver', 'chauffeur', 'company driver', 'courier',
    'delivery driver', 'transportation', 'driving'
  ],

  'Studio Runner': [
    'studio runner', 'runner', 'production runner',
    'production assistant', 'studio assistant', 'set runner',
    'junior pa'
  ],

  'Telesales Specialist': [
    'telesales', 'telemarketing', 'inside sales',
    'phone sales', 'sales specialist', 'tele sales',
    'outbound sales', 'call center sales'
  ]
};

/**
 * Get search keywords for a position title
 * @param {string} positionTitle - The position title
 * @returns {Array} Array of keywords for this position
 */
export const getPositionKeywords = (positionTitle) => {
  // Try exact match first
  if (positionKeywords[positionTitle]) {
    return positionKeywords[positionTitle];
  }

  // Try case-insensitive match
  const titleLower = positionTitle.toLowerCase();
  for (const [key, keywords] of Object.entries(positionKeywords)) {
    if (key.toLowerCase() === titleLower) {
      return keywords;
    }
  }

  // Try partial match (for positions not in the mapping)
  for (const [key, keywords] of Object.entries(positionKeywords)) {
    if (titleLower.includes(key.toLowerCase()) || key.toLowerCase().includes(titleLower)) {
      return keywords;
    }
  }

  return [];
};

/**
 * Enhanced search function that matches against both title and keywords
 * @param {string} searchText - The search query
 * @param {string} positionTitle - The position title to match against
 * @returns {boolean} True if search matches title or keywords
 */
export const matchesPositionSearch = (searchText, positionTitle) => {
  if (!searchText) return true;

  const searchLower = searchText.toLowerCase().trim();
  const titleLower = positionTitle.toLowerCase();

  // Match against title (exact or partial)
  if (titleLower.includes(searchLower)) {
    return true;
  }

  // Split search text into words for multi-word matching
  const searchWords = searchLower.split(/\s+/);

  // Check if all search words are in the title (for multi-word searches)
  if (searchWords.length > 1) {
    const allWordsMatch = searchWords.every(word =>
      word.length > 1 && titleLower.includes(word)
    );
    if (allWordsMatch) return true;
  }

  // Get base position title (without Junior/Senior suffixes)
  const baseTitle = positionTitle
    .replace(/ - (Junior|Senior)$/i, '')
    .replace(/ (Junior|Senior)$/i, '')
    .trim();

  // Match against keywords for the exact position
  let keywords = getPositionKeywords(positionTitle);

  // If no exact match, try base position (without seniority)
  if (keywords.length === 0 && baseTitle !== positionTitle) {
    keywords = getPositionKeywords(baseTitle);

    // Add seniority-related keywords
    if (positionTitle.toLowerCase().includes('senior')) {
      keywords = [...keywords, 'senior', 'lead', 'sr', 'principal', 'experienced'];
    } else if (positionTitle.toLowerCase().includes('junior')) {
      keywords = [...keywords, 'junior', 'jr', 'entry level', 'entry-level', 'associate', 'beginner'];
    }
  }

  // Fallback: Extract meaningful words from position title as keywords
  if (keywords.length === 0) {
    // Split title into words and use them as keywords
    const titleWords = titleLower
      .split(/[\s\-/]+/)
      .filter(word => word.length > 2); // Ignore short words
    keywords = titleWords;
  }

  // Match search text against keywords
  return keywords.some(keyword =>
    keyword.toLowerCase().includes(searchLower) ||
    searchLower.includes(keyword.toLowerCase())
  );
};

export default positionKeywords;
